import { _,moment } from '../../vendor';

/**
 * @method getOpeningTimes
 * 
 * @param {Object} checkInPeriods 
 * @param {Moment} bookingBegin Optional | Date within period to be searched for
 * 
 * @return {Object} List of active and upcoming seasons 
 */
const getOpeningTimes: (checkInPeriods: any, bookingBegin?: any) => {
    activeSeason: any;
    activeSeasonPeriod: any;
    nextAvailableSeason: any;
    nextAvailableSeasonPeriod: any
} = (checkInPeriods: any, bookingBegin: any = moment()): {
    activeSeason: any;
    activeSeasonPeriod: any;
    nextAvailableSeason: any;
    nextAvailableSeasonPeriod: any
} => {

    let activeSeason: any,
        activeSeasonPeriod: any,
        nextAvailableSeason: any,
        nextAvailableSeasonPeriod: any,
        periodsAmount: number = _.size(checkInPeriods);

    _.each(checkInPeriods, (season: any, seasonPeriod: any): void => {

        const fromDate: any = moment(seasonPeriod, 'YYYY-MM-DD');

        if (fromDate.isValid()) {
            // seasonPeriod must be a date-string

            // Get most previous opening time
            if (periodsAmount == 1
                || (fromDate.isSameOrBefore(bookingBegin)
                    && (typeof activeSeasonPeriod === 'undefined'
                        ? true
                        : fromDate.isAfter(activeSeasonPeriod)
                       )
                    )
                ) {

                activeSeason = season;
                activeSeasonPeriod = fromDate;

            } else {
                
                // Get most previous NEXT opening time
                if (fromDate.isAfter(bookingBegin)
                    && (typeof nextAvailableSeason === 'undefined'
                        ? true
                        : fromDate.isBefore(nextAvailableSeasonPeriod)
                        )
                    ) {

                    nextAvailableSeasonPeriod = fromDate;
                    nextAvailableSeason = season;

                }

            }
        }
    });

    return {
        activeSeason,
        activeSeasonPeriod,
        nextAvailableSeason,
        nextAvailableSeasonPeriod
    }

};

export default { getOpeningTimes }